import React, { Component } from "react";
import ReactTable from "react-table";
import moment from "moment";
import { connect } from "react-redux";
import Spinner from "../../../common/Spinner";
import filterCaseInsensitive from "../../../custom/forms/react-table-case-insensitive";

class OrderHistoryList extends Component {
    getColumns = () => {
        const columns = [];

        columns.push({
            Header: "Order #",
            headerClassName: "text-left",
            accessor: "orderId"
        });
        columns.push({
            Header: "Merchandiser",
            headerClassName: "text-left",
            accessor: "merchandiser"
        });
        columns.push({
            Header: "Supplier",
            headerClassName: "text-left",
            accessor: "supplier"
        });
        columns.push({
            Header: "Retailer",
            headerClassName: "text-left",
            accessor: "retailer"
        });
        columns.push({
            Header: "JobNumber",
            headerClassName: "text-left",
            accessor: "jobNumber"
        });
        columns.push({
            Header: "StoreNumber",
            headerClassName: "text-left",
            accessor: "storeNumber"
        });
        columns.push({
            Header: "PlanogramCode",
            headerClassName: "text-left",
            accessor: "planogramCode"
        });
        columns.push({
            id: "noOrderNeeded",
            Header: "NoOrderNeeded",
            headerClassName: "text-left",
            accessor: original => (original.noOrderNeeded ? "Yes" : "No"),
            // Cell: ({ original }) => (original.isTemporary ? "Yes" : "No"),
        });
        columns.push({
            id: "submittedDate",
            Header: "SubmittedDate",
            headerClassName: "text-left",
            accessor: original => moment(original.submittedDate)
                .format("MM/DD/YYYY h:mm A")
        });
        columns.push({
            id: "exportDate",
            Header: "ExportDate",
            headerClassName: "text-left",
            accessor: original => moment(original.exportDate)
                .format("MM/DD/YYYY h:mm A")
        });
        columns.push({
            Header: "ExportFileName",
            headerClassName: "text-left",
            accessor: "exportFileName"
        });
        columns.push({
            Header: "ExportedBy",
            headerClassName: "text-left",
            accessor: "exportedBy"
        });

        return columns;
    };

    render() {
        const {
            historyLoading,
            ordersHistory
        } = this.props;

        return (
            <div className="dashboard">
                <div className="position-relative">
                    {!historyLoading || <Spinner/>}
                </div>
                <div className="mb-4">
                    <ReactTable
                        data={ordersHistory}
                        columns={this.getColumns()}
                        headerClassName="table-header"
                        showPagination={false}
                        pageSize={Math.max(ordersHistory.length, 20)}
                        resizable
                        className="-striped -highlight"
                        filterable={false}
                        defaultFilterMethod={filterCaseInsensitive}
                        getNoDataProps={() => ({
                            style: {
                                zIndex: 0
                            }
                        })}
                        style={{
                            height: "calc(100vh - 300px)",
                        }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    historyLoading: state.export.historyLoading,
    ordersHistory: state.export.ordersHistory
});

export default connect(
    mapStateToProps
)(OrderHistoryList);
